<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Create New Hardware Revision'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-hashtag"></p-inputicon>
                <input
                        pInputText
                        id="sample-hardware-revision-pcb-version"
                        [(ngModel)]="this.sampleHardwareRevision.pcbVersion"
                        autocomplete="off"
                        class="w-full"
                        placeholder="x.x.x"
                />
            </p-iconfield>
            <label for="sample-hardware-revision-pcb-version">PCB Version <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-iftalabel>
            <textarea pTextarea id="description" [(ngModel)]="this.sampleHardwareRevision.description" rows="5" class="w-full"></textarea>
            <label for="description">Brief Description About This Revision <span class="text-red-500">*</span></label>
        </p-iftalabel>

        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="updateSampleHardwareRevision()"
                [disabled]="this.saveDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>